import { atom, getDefaultStore } from 'jotai';
import { CpOrderInvoicesDataItem, CpOrderInvoicesListPageState } from './cp_order_invoices_list_types';
import { tableStateVM, tableStatsVM, tableViewVM } from '../../../core/table/table_view_models';
import { TableDataState, TableFilters, TableState, TblStats, TblView } from '../../../core/table/table.types';
import { cpOrderInvoicesListPageStateVM } from './cp_order_invoices_list_view_models';
import tableViewRepo from '../../../core/repo/viewStateRepo';
import { stripAwayFormErrors } from '../../../core/table/utils/stripAwayFormErrors';
import { CP_ORDER_INVOICES_LIST_FORM_KEY, CP_ORDER_INVOICES_LIST_STORAGE_KEY } from '../cp_order_invoices_const';
import { CpOrderInvoicesSearchModel } from './search/cp_order_invoices_search_types';
import { cpOrderInvoicesSearchStateVM } from './search/cp_order_invoices_search_view_models';

export const cpOrderInvoicesPageStateAtom = atom<CpOrderInvoicesListPageState>(cpOrderInvoicesListPageStateVM());

export const cpOrderInvoicesPageActionAtom = atom(get => get(cpOrderInvoicesPageStateAtom).action);
export const cpOrderInvoicesUserTypeAtom = atom(get => get(cpOrderInvoicesPageStateAtom).userType);
export const cpOrderInvoicesUserAffListAtom = atom(get => get(cpOrderInvoicesPageStateAtom).userAffList);
export const cpOrderInvoicesUserImpersonateAtom = atom(get => get(cpOrderInvoicesPageStateAtom).userImpersonate);

export const cpOrderInvoicesTableStateAtom = atom<TableState>(tableStateVM());
export const cpOrderInvoicesDataAtom = atom<TableDataState<CpOrderInvoicesDataItem>>({ items: [], dataItems: [] });
export const cpOrderInvoicesTableViewAtom = atom<TblView>(tableViewVM());
export const cpOrderInvoicesTableStatsAtom = atom<TblStats>(tableStatsVM());
export const cpOrderInvoicesTableFiltersAtom = atom<TableFilters>({});
export const cpOrderInvoicesSearchFormAtom = atom<CpOrderInvoicesSearchModel>(cpOrderInvoicesSearchStateVM());

export function setAtomCpOrderInvoicesListTableViewState(atomsDestroyed: boolean = false): void {
    // on Table exit save viewstate
    // note this can read the current Jotai values without subscribing (Jotai accessors)
    if (atomsDestroyed) {
        return;
    }
    // on Table exit save viewstate
    const defaultStore = getDefaultStore();
    const flt = defaultStore.get<TableFilters>(cpOrderInvoicesTableFiltersAtom);
    const stats = defaultStore.get<TblStats>(cpOrderInvoicesTableStatsAtom);
    const view = defaultStore.get<TblView>(cpOrderInvoicesTableViewAtom);
    tableViewRepo.setTable(CP_ORDER_INVOICES_LIST_STORAGE_KEY, flt, stats.paging, view.sort);
}

export function setAtomCpOrderInvoicesFormState(): void {
    // on Table exit save viewstate
    const defaultStore = getDefaultStore();
    const formState = defaultStore.get<CpOrderInvoicesSearchModel>(cpOrderInvoicesSearchFormAtom);
    tableViewRepo.setForm(CP_ORDER_INVOICES_LIST_FORM_KEY, stripAwayFormErrors(formState));
}
